import { Link, NavLink, useNavigate } from "react-router-dom";
import { Camera, LogIn, LogOut, Store, ShieldCheck, Home as HomeIcon, Menu } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { useState } from "react";

export default function Nav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const doLogout = async () => {
    await logout();
    navigate("/");
  };

  const links = (
    <>
      <NavLink to="/" end className={({isActive}) => `px-3 py-2 rounded-lg text-sm font-semibold ${isActive ? "text-emerald-800 bg-emerald-50" : "text-slate-700 hover:text-emerald-800"}`} data-testid="nav-home">
        <HomeIcon className="inline w-4 h-4 mr-1.5 -mt-0.5" />Deals
      </NavLink>
      <NavLink to="/stores" className={({isActive}) => `px-3 py-2 rounded-lg text-sm font-semibold ${isActive ? "text-emerald-800 bg-emerald-50" : "text-slate-700 hover:text-emerald-800"}`} data-testid="nav-stores">
        <Store className="inline w-4 h-4 mr-1.5 -mt-0.5" />Stores
      </NavLink>
      {user && user.role === "store" && (
        <NavLink to="/dashboard" className={({isActive}) => `px-3 py-2 rounded-lg text-sm font-semibold ${isActive ? "text-emerald-800 bg-emerald-50" : "text-slate-700 hover:text-emerald-800"}`} data-testid="nav-dashboard">
          <Camera className="inline w-4 h-4 mr-1.5 -mt-0.5" />Snap & List
        </NavLink>
      )}
      {user && user.role === "store" && (
        <NavLink to="/scan" className={({isActive}) => `px-3 py-2 rounded-lg text-sm font-semibold ${isActive ? "text-emerald-800 bg-emerald-50" : "text-slate-700 hover:text-emerald-800"}`} data-testid="nav-scan">
          <span className="inline-block w-4 h-4 mr-1.5 -mt-0.5 align-middle">📷</span>Scan
        </NavLink>
      )}
      {user && user.role === "admin" && (
        <NavLink to="/admin" className={({isActive}) => `px-3 py-2 rounded-lg text-sm font-semibold ${isActive ? "text-emerald-800 bg-emerald-50" : "text-slate-700 hover:text-emerald-800"}`} data-testid="nav-admin">
          <ShieldCheck className="inline w-4 h-4 mr-1.5 -mt-0.5" />Admin
        </NavLink>
      )}
    </>
  );

  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-white/85 border-b border-slate-200/70">
      <div className="bg-emerald-900 text-emerald-100 px-4 py-1.5 text-xs sm:text-sm flex justify-between items-center">
        <span data-testid="kia-ora-banner">Mōrena! Fresh in-store markdowns across Aotearoa NZ 🇳🇿</span>
        <span className="hidden sm:inline text-emerald-200/80">Powered by Blurblive.nz</span>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="brand-link">
          <img src="/blurblive-logo.png" alt="Blurblive.nz" className="h-9 sm:h-10 w-auto" />
          <span className="hidden sm:inline-block text-[10px] uppercase tracking-widest text-emerald-800 font-black bg-emerald-100 px-2 py-0.5 rounded-full">Markdowns</span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">{links}</nav>

        <div className="flex items-center gap-2">
          {user ? (
            <>
              <span className="hidden sm:block text-xs text-slate-500 mr-1" data-testid="user-email">{user.email}</span>
              <Button size="sm" variant="outline" onClick={doLogout} data-testid="logout-btn" className="border-slate-300">
                <LogOut className="w-4 h-4 mr-1.5" />Log out
              </Button>
            </>
          ) : (
            <>
              <Button size="sm" variant="ghost" onClick={() => navigate("/login")} data-testid="login-btn" className="hidden sm:inline-flex">
                <LogIn className="w-4 h-4 mr-1.5" />Log in
              </Button>
              <Button size="sm" onClick={() => navigate("/register")} data-testid="register-cta" className="bg-emerald-800 hover:bg-emerald-900 text-white">
                <Store className="w-4 h-4 mr-1.5" />List your store
              </Button>
            </>
          )}
          <button className="md:hidden p-2 rounded-lg hover:bg-slate-100" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
            <Menu className="w-5 h-5" />
          </button>
        </div>
      </div>
      {open && (
        <div className="md:hidden border-t border-slate-200 px-4 py-2 flex flex-col gap-1 bg-white">{links}</div>
      )}
    </header>
  );
}
